// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BottomNav.css — Barra inferior fija + menú "Más" (dropdown estilo hamburguesa) */

.bn-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  background: var(--sn-superficie);
  border-top: 1px solid var(--sn-borde);
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

/* Reserva el alto de la barra MÁS la barra de navegación del sistema: con
   targetSdk 36 la app va de borde a borde y .bn-bar suma ese inset abajo. Sin
   él, la barra tapaba lo que queda al final del scroll (p. ej. el botón fijo
   de WhatsApp en Promociones Internet con la navegación de 3 botones). */
.bn-spacer {
  height: calc(76px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
}

.bn-item {
  flex: 1 1;
  background: none;
  border: none;
  padding: 8px 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: var(--sn-texto-2);
  font-size: 10px;
}

.bn-item-icon {
  font-size: 18px;
}

.bn-more-toggle-btn::after {
  display: none;
}

.bn-more-menu {
  border-radius: 14px;
  border: 1px solid var(--sn-borde);
  box-shadow: var(--sn-sombra);
  padding: 6px;
  width: 240px;
  max-width: 80vw;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.bn-more-title {
  padding: 8px 14px 4px;
  font-size: 13px;
  font-weight: 800;
  color: var(--sn-marca-fuerte);
}

.bn-more-item {
  border-radius: 10px;
  padding: 8px 8px;
  font-size: 14px;
  width: 100%;
}

.bn-more-item:hover,
.bn-more-item:focus {
  background: var(--sn-superficie-2);
}

.bn-more-item-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--sn-superficie-2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: var(--sn-marca);
  flex-shrink: 0;
}

.bn-more-item-icon--danger {
  background: var(--sn-peligro-suave);
  color: var(--sn-peligro-texto);
}
`, "",{"version":3,"sources":["webpack://./src/components/BottomNav.css"],"names":[],"mappings":"AAAA,mFAAmF;;AAEnF;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,qCAAqC;EACrC,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;;;yEAGyE;AACzE;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC","sourcesContent":["/* BottomNav.css — Barra inferior fija + menú \"Más\" (dropdown estilo hamburguesa) */\n\n.bn-bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1030;\n  background: var(--sn-superficie);\n  border-top: 1px solid var(--sn-borde);\n  display: flex;\n  justify-content: space-around;\n  align-items: stretch;\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n/* Reserva el alto de la barra MÁS la barra de navegación del sistema: con\n   targetSdk 36 la app va de borde a borde y .bn-bar suma ese inset abajo. Sin\n   él, la barra tapaba lo que queda al final del scroll (p. ej. el botón fijo\n   de WhatsApp en Promociones Internet con la navegación de 3 botones). */\n.bn-spacer {\n  height: calc(76px + env(safe-area-inset-bottom, 0px));\n  flex-shrink: 0;\n}\n\n.bn-item {\n  flex: 1;\n  background: none;\n  border: none;\n  padding: 8px 2px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  color: var(--sn-texto-2);\n  font-size: 10px;\n}\n\n.bn-item-icon {\n  font-size: 18px;\n}\n\n.bn-more-toggle-btn::after {\n  display: none;\n}\n\n.bn-more-menu {\n  border-radius: 14px;\n  border: 1px solid var(--sn-borde);\n  box-shadow: var(--sn-sombra);\n  padding: 6px;\n  width: 240px;\n  max-width: 80vw;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.bn-more-title {\n  padding: 8px 14px 4px;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--sn-marca-fuerte);\n}\n\n.bn-more-item {\n  border-radius: 10px;\n  padding: 8px 8px;\n  font-size: 14px;\n  width: 100%;\n}\n\n.bn-more-item:hover,\n.bn-more-item:focus {\n  background: var(--sn-superficie-2);\n}\n\n.bn-more-item-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--sn-superficie-2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  color: var(--sn-marca);\n  flex-shrink: 0;\n}\n\n.bn-more-item-icon--danger {\n  background: var(--sn-peligro-suave);\n  color: var(--sn-peligro-texto);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
